import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';

import { DeltaAtom } from '../../../atoms/icon-atoms/icon-atoms';

const ListingTableKey = ({ className }) => {
  return (
    <div className={className}>
      <DeltaAtom deltaValue={1} isValueDisplayed={false} />
      <DeltaAtom
        className="delta-down"
        deltaValue={-1}
        isValueDisplayed={false}
      />
      <span className="text">change from prior year in percentage points</span>
    </div>
  );
};

// === ListingTableKey CSS ===
const StyledListingTableKey = styled(ListingTableKey)`
  display: flex;
  align-itmes: center;
  padding: 0 2rem ${vars.spacingM} 2rem;
  @media screen and (min-width: ${vars.breakPointTwelveColumn}) {
    padding: 0 ${vars.spacingS} ${vars.spacingM} ${vars.spacingS};
  }
  .text {
    font-weight: ${vars.fontWeightMedium};
    ${vars.fontSize1}
  }
  background-color: ${vars.greyHavens};
  ${DeltaAtom} {
    transform: scale(0.7);
    &.delta-down {
      margin-left: -0.5rem;
      top: 0;
    }
  }
`;

export default StyledListingTableKey;
